const ManifestIcon = ({color}) => {
    
  return(
       <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M0 1.9C0 0.850659 0.850659 0 1.9 0H17.1C18.1493 0 19 0.850659 19 1.9V6.65C19 7.69934 18.1493 8.55 17.1 8.55H1.9C0.850659 8.55 0 7.69934 0 6.65V3.8V1.9ZM17.1 1.9H1.9V3.8V6.65H17.1V1.9ZM0 13.3C0 12.7753 0.42533 12.35 0.95 12.35L18.05 12.35C18.5747 12.35 19 12.7753 19 13.3C19 13.8247 18.5747 14.25 18.05 14.25L0.95 14.25C0.42533 14.25 0 13.8247 0 13.3ZM0.95 17.1C0.42533 17.1 0 17.5253 0 18.05C0 18.5747 0.42533 19 0.95 19L18.05 19C18.5747 19 19 18.5747 19 18.05C19 17.5253 18.5747 17.1 18.05 17.1L0.95 17.1Z" fill={color}/>
        </svg>
    )
}

export default ManifestIcon